/**
 * This function is used to override the position of the tutorial tooltip.
 * It is used in the Tutorial component.
 *
 * @param {Object} position - The position of the tooltip.
 * @param {Object} currentEvent - The current event.
 * @param {Object} currentTarget - The current target.
 * @param {Object} node - The node.
 * @returns {Object} - The new position of the tooltip.
 */

const overrideTooltipPosition = (
  { left, top },
  currentEvent,
  currentTarget,
  node,
) => {
  const d = document.documentElement;
  const newLeft = Math.max(
    0,
    Math.min(d.clientWidth - node.clientWidth, left) - 10,
  );
  const newTop = Math.max(
    0,
    Math.min(d.clientHeight - node.clientHeight, top) + 3,
  );
  return { top: newTop, left: newLeft };
};

module.exports = { overrideTooltipPosition };
